import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact'
import ContentHtmlCard from './../../../../components/content/ContentHtmlCard/ContentHtmlCard.component'
import { renderVideo } from '../../../../components/content/ContentVideo/renderVideo'
import TrainingValidator from '../../../TrainingPages/components/TrainingValidator/TrainingValidator.component'
import AdminApi from '../../../../api/admin-api/admin-api'

const USE_INTRO_CONTENT = false

const AgentWelcomeIntro = ({
  isAffiliateAgent,
  isAssociateAgent,
  isSignatureAgent,
  isCsrAgent,
  video,
  init,
}) => {
  const [stepsContentID, setStepsContentID] = useState(null)
  const [introContentID, setIntroContentID] = useState(null)

  useEffect(() => {
    const getSlugByAgent = (typeMap) => {
      if (isAffiliateAgent) return typeMap.affiliate
      if (isAssociateAgent) return typeMap.associate
      if (isSignatureAgent) return typeMap.signature
      if (isCsrAgent) return typeMap.csr
      return null
    }

    const fetchContentIdBySlug = async (slug, setter) => {
      if (!slug) return
      try {
        const response = await AdminApi.getAgencyContentBySlug({ slug })
        const content = response?.data?.data?.shift()
        if (content?.id) {
          setter(content.id)
        }
      } catch (ex) {
        console.error(`Failed to fetch content for slug "${slug}":`, ex)
      }
    }

    fetchContentIdBySlug(
      getSlugByAgent({
        affiliate: 'affiliate-getting-started',
        associate: 'associate-getting-started',
        signature: 'signature-getting-started',
        csr: 'csr-getting-started',
      }),
      setStepsContentID
    )

    fetchContentIdBySlug(
      getSlugByAgent({
        affiliate: 'affiliate-welcome-intro',
        associate: 'associate-welcome-intro',
        signature: 'signature-welcome-intro',
        csr: 'csr-welcome-intro',
      }),
      setIntroContentID
    )
  }, [isAffiliateAgent, isAssociateAgent, isSignatureAgent, isCsrAgent])

  if (!video) return <></>
  return (
    <main id="AgentWelcomeIntroPage" className="mainSection">
      <MDBContainer>
        {USE_INTRO_CONTENT ? (
          <MDBRow>
            <MDBCol
              size="12"
              sm={video ? '4' : '0'}
              md={video ? '4' : '0'}
              lg={video ? '4' : '0'}
              className="video-wrapper"
            >
              {renderVideo(video.training_link, video.training_name)}
            </MDBCol>
            <MDBCol size={video ? '8' : '12'}>
              <ContentHtmlCard contentId={introContentID} fullHeight />
            </MDBCol>
          </MDBRow>
        ) : (
          <MDBRow>
            <MDBCol
              size="12"
              md="8"
              xl="10"
              className="video-wrapper offset-md-2 offset-xl-1"
            >
              {renderVideo(video.training_link, video.training_name)}
            </MDBCol>
          </MDBRow>
        )}
        {video && (!video.training_code || video.hasCompleted.current) ? (
          <></>
        ) : (
          <div className="my-4">
            <TrainingValidator
              trainings={video ? [video] : []}
              onSuccess={init}
              isOnboarding={true}
            />
          </div>
        )}
        <br />
        <MDBRow>
          <MDBCol size="12">
            <ContentHtmlCard contentId={stepsContentID} />
          </MDBCol>
        </MDBRow>
        <br />
      </MDBContainer>
    </main>
  )
}

export default observer(AgentWelcomeIntro)
